export const CHAT_DRAWER_TEST_IDS = {
  streamingMessage: 'chatbot-streaming-message',
  typingIndicator: 'chatbot-typing-indicator',
  errorAlert: 'chatbot-error-alert',
  retryButton: 'chatbot-retry-button',
};
